import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({
  colors,
  spacing,
  borders,
}: Theme) => createStyles({
  root: {
    padding: spacing(1),
    marginRight: spacing(1),
    color: colors.controls.options.enabled.icon,
    borderRadius: borders.radius1,
    '&:hover': {
      backgroundColor: colors.controls.options.hovered.hoverArea,
    },
    '&:active': {
      backgroundColor: colors.controls.options.pressed.hoverArea,
    },
  },
  label: {
    display: 'inline-flex',
    marginLeft: 0,
    color: colors.controls.options.enabled.text,
    '& .Mui-disabled': {
      color: colors.controls.options.disabled.text,
    },
  },
  labelText: {
    marginRight: spacing(0.5),
  },
});

export default styles;
